import {
  LookupSource,
  LookupOption,
  createEntireLoadLookupSource,
} from '@/components';
import { RtkqSpin, useLazyGetProjectLookupsQuery } from '@/redux';
import { useMemo } from 'react';

export function mapProjectLookup(value: {
  id: string;
  name: string;
}): LookupOption {
  const { name } = value;

  return {
    _search: name,
    value: value.id,
    label: name,
  };
}

interface Props {
  clientIds?: string[];
  communityIds?: string[];
  ids?: string[];
  isActive?: boolean;
}

export function useProjectLookupSource(props: Props): LookupSource {
  const { clientIds, communityIds, ids, isActive } = props;
  const [fetchList] = useLazyGetProjectLookupsQuery();

  return useMemo(() => {
    const entireSource = createEntireLoadLookupSource({
      initial: (id: string) =>
        fetchList(
          { clientIds, communityIds, ids, isActive, [RtkqSpin]: false },
          true,
        )
          .unwrap()
          .then((values) => mapProjectLookup(values.find((x) => x.id === id)!)),
      load: () =>
        fetchList(
          { clientIds, communityIds, ids, isActive, [RtkqSpin]: false },
          true,
        )
          .unwrap()
          .then((values) => values.map(mapProjectLookup)),
    });

    return { ...entireSource, searchField: '_search' };
  }, [fetchList, clientIds, communityIds, ids, isActive]);
}
